<script>
	import DropdownList from '$lib/Components/Layout/DropdownList/DropdownList.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
</script>

<Section>
	<h2>READ MORE INDOW STORIES HERE:</h2>
	<ul
		class="grid w-full list-none grid-cols-[repeat(auto-fit,minmax(15rem,1fr))]"
	>
		<li>
			<DropdownList title="COMFORT">
				<li>
					<a href="/resources/case-studies/window-replacement-alternative"
						>Say No to Replacing Windows</a
					>
				</li>
			</DropdownList>
		</li>
		<li>
			<DropdownList title="NOISE REDUCTION">
				<li>
					<a href="/resources/case-studies/street-noise-reduction"
						>Attaining Quiet in Portland, OR</a
					>
				</li>
				<li>
					<a href="/resources/case-studies/this-old-house-charleston"
						>This Old House: Charleston, SC</a
					>
				</li>
			</DropdownList>
		</li>
		<li>
			<DropdownList title="HEALTH & SAFETY">
				<li>
					<a href="/resources/case-studies/stop-window-condensation"
						>Eliminating Window Condensation</a
					>
				</li>
			</DropdownList>
		</li>
		<li>
			<DropdownList title="ENERGY SAVINGS">
				<li>
					<a href="/resources/case-studies/energy-efficiency-old-homes"
						>US Department of Energy Study</a
					>
				</li>
			</DropdownList>
		</li>
		<li>
			<DropdownList title="LIGHT & UV">
				<li>
					<a href="/resources/case-studies/window-privacy-ideas"
						>City Window Privacy Ideas</a
					>
				</li>
			</DropdownList>
		</li>
		<li>
			<DropdownList title="COMMERCIAL PROJECTS">
				<li>
					<a href="/resources/case-studies/office-soundproofing"
						>Soundproofing Office Windows</a
					>
				</li>
				<li>
					<a href="/resources/case-studies/church-storm-windows"
						>Church Storm Windows – Heating Congregations</a
					>
				</li>
			</DropdownList>
		</li>
	</ul>
</Section>
